module.exports = __webpack_public_path__ + "img/re-result-1.0f923c53.jpg";